export type TypoLevel = 1 | 2 | 3 | 4;

export interface CustomTextInput {
  placeholder?: string;
  valueKey: string; // Value key to use in the editor user.uuid, user.name, .....
}

export enum EditorMode {
  COMPLETE = "complete", // Can manage the inputs and the sign
  VIEWER = "viewer", // Can olny view de document
  EDITOR = "editor", // Can edit the document
}

export enum InputDataType {
  CHECKBOX = "checkbox",
  INPUT = "input",
  SIGN = "sign",
  SIGNED_AT = "signed_at",
}

export interface InputData<T = unknown> {
  name: string;
  type: InputDataType;
  value?: T;
}

export interface InputDataCheckbox extends InputData<boolean> {
  type: InputDataType.CHECKBOX;
}

export interface InputDataInput extends InputData<string> {
  type: InputDataType.INPUT;
}

export interface InputDataSign extends InputData<string> {
  type: InputDataType.SIGN;
}

export interface InputDataSignedAt extends InputData<string> {
  type: InputDataType.SIGNED_AT;
}

export type InputDataRaw<T> = Pick<InputData<T>, "name" | "value">;
export type SignDataRaw = Pick<InputData<string>, "name" | "value">;
export interface CustomCheckboxOptions {
  mode: EditorMode;
  onChange?: (inputData: InputDataRaw<boolean>) => void;
}

export interface CustomSignOptions {
  mode: EditorMode;
  onClick?: (inputData: SignDataRaw) => void;
}

export interface CustomInputOptions {
  mode: EditorMode;
  onChange?: (inputData: InputDataRaw<string>) => void;
}
